// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ComponentStatisticsListed_header__658t\\+ {
    margin-bottom: 25px;
}

.ComponentStatisticsListed_title__d4fSQ {
    font-size: 30px;
}

.ComponentStatisticsListed_chart_box_main__Iwozr {

}

.ComponentStatisticsListed_chart_box_header__NVDr1 {

}

.ComponentStatisticsListed_chart_box_item__aEDSp {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 500px;
}

.ComponentStatisticsListed_table_box_item__F7H6c {
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/components/ComponentStatisticsListed/index.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;AAEA;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".header {\n    margin-bottom: 25px;\n}\n\n.title {\n    font-size: 30px;\n}\n\n.chart_box_main {\n\n}\n\n.chart_box_header {\n\n}\n\n.chart_box_item {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 500px;\n}\n\n.table_box_item {\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `ComponentStatisticsListed_header__658t+`,
	"title": `ComponentStatisticsListed_title__d4fSQ`,
	"chart_box_main": `ComponentStatisticsListed_chart_box_main__Iwozr`,
	"chart_box_header": `ComponentStatisticsListed_chart_box_header__NVDr1`,
	"chart_box_item": `ComponentStatisticsListed_chart_box_item__aEDSp`,
	"table_box_item": `ComponentStatisticsListed_table_box_item__F7H6c`
};
export default ___CSS_LOADER_EXPORT___;
